export const enum LiveStreamComponent {
  HLS = 'hls',
  YOUTUBE = 'youTube',
  TWITCH = 'twitch',
}
